import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import VendorApplications from '../../Components/VendorApplications/VendorApplications';

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = () => ({});

/**
 * Connects dashboard state to the VendorApplications component

 * @param {object} mapStateToProps data object to become props for the VendorApplications component
 * @param {object} mapDispatchToProps actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendorApplications),
);
